import React, { FC } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Rows from "./Rows";
import {
  Box,
  CircularProgress,
  Pagination,
  TableSortLabel,
} from "@mui/material";
import useReusableTable from "./view/useReusableTable";
import { Column } from "../../../interfaces/table";
import NoRows from "./NoRows";
import { visuallyHidden } from "@mui/utils";
interface IReusableTable {
  columns: Column[];
  rows: any[];
  onRowClick?: (data: any) => void;
  page?: number;
  onPageChange?: (page: any) => void;
  totalCount?: number | null;
  perPage?: number;
  loading?: Boolean;
  meta?: any;
  orderBy?: string;
  orderType?: "asc" | "desc";
  createSortHandler?: (
    orderBy: string | null,
    orderType: string | null
  ) => void;
  tableContainerClassName?: string;
  totalRows?: any;
}
const ReusableTable: FC<IReusableTable> = ({
  columns = [],
  rows = [],
  onRowClick,
  page,
  onPageChange,
  totalCount,
  perPage,
  loading = false,
  orderBy,
  orderType,
  createSortHandler,
  tableContainerClassName,
  totalRows = 0,
}) => {
  const {
    // page,
    // onPageChange,
    isSelected,
    handleItemClick,
    // handleSelectAllClick,
    // selected,
    onTableHeaderSortClicked,
  } = useReusableTable({ rows, createSortHandler, orderBy, orderType });
  return (
    <>
      <TableContainer
        component={Paper}
        className={tableContainerClassName ? tableContainerClassName : ""}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {/* commented for now as we dont have requirement for checkbox selection */}
              {/* <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  indeterminate={
                    selected.length > 0 && selected.length < rows.length
                  }
                  checked={
                    rows?.length > 0 && selected?.length === rows?.length
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{
                    "aria-label": "select all desserts",
                  }}
                />
              </TableCell> */}
              {columns?.map((column) => (
                <>
                  {column.isSortable ? (
                    <TableCell
                      sx={{
                        borderRight: "1px solid #EAEAEA",
                        fontWeight: 500,
                        fontSize: "16px",
                      }}
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      sortDirection={orderBy === column.id ? orderType : false}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? orderType : "asc"}
                        onClick={() =>
                          onTableHeaderSortClicked(
                            column.sortKey ? column.sortKey : column.key
                          )
                        }
                      >
                        {column.label}
                        {orderBy === column.id ? (
                          <Box component="span" sx={visuallyHidden}>
                            {orderType === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                  ) : (
                    <TableCell
                      sx={{ borderRight: "1px solid #EAEAEA" }}
                      key={column.id}
                      align={column.align}
                      className="capitalize"
                    >
                      {column.label}
                    </TableCell>
                  )}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody id="table-container" className="">
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length + 1}>
                  <div className="my-28 flex justify-center">
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : rows.length > 0 ? (
              rows?.map((row: any, index: number) => (
                <Rows
                  key={row.id}
                  row={row}
                  columns={columns}
                  isItemSelected={isSelected(row.id)}
                  index={index}
                  onRowClick={onRowClick}
                  handleItemClick={handleItemClick}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1}>
                  <div className="my-28">
                    <NoRows />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {(rows.length > 0 && !!totalCount && totalCount > 0 )&& (
        <div className="flex justify-between bg-white pl-2 py-2">
          {(totalRows && page && perPage )? (
            <div>
              {(page-1) * perPage + 1} to {(page-1) * perPage + rows.length} out of{" "}
              {totalRows}
            </div>
          ):null}
          <Pagination
            color="primary"
            count={totalCount ? totalCount : 0}
            onChange={(event, value) => {
              if (onPageChange) {
                onPageChange(value);
              }
            }}
            page={page}
            size="large"
          ></Pagination>
        </div>
      )}
    </>
  );
};

export default ReusableTable;
